import { CalculationResultType } from '../../../../../../../services/common/CalculatorUtils';
import React from 'react';
import StringType from './stringType';
import ArithmeticType from './arithmeticType';
import BooleanType from './booleanType';
import { FieldType } from 'services/common/Constants';
import DateCriterionValue from '../dateCriterionValue';

const CalculatedValue = ({
  selectedOperator,
  fieldName,
  showLabel,
  availableValueOptions,
  selectedFieldSubType,
}) => {
  switch (selectedFieldSubType) {
    case CalculationResultType.STRING:
      return (
        <StringType
          selectedFieldSubType={selectedFieldSubType}
          selectedOperator={selectedOperator}
          fieldName={fieldName}
          availableValueOptions={availableValueOptions}
        />
      );
    case CalculationResultType.ARITHMETIC_FORMULA_OUTPUT:
      return (
        <ArithmeticType
          fieldName={fieldName}
          showLabel={showLabel}
          availableValueOptions={availableValueOptions}
          selectedOperator={selectedOperator}
        />
      );
    case CalculationResultType.BOOLEAN:
      return (
        <BooleanType
          fieldName={fieldName}
          showLabel={showLabel}
          selectedOperator={selectedOperator}
        />
      );
    case FieldType.DATE:
      return (
        <DateCriterionValue
          selectedOperator={selectedOperator}
          fieldName={fieldName}
          showLabel={showLabel}
        />
      );
    default:
      break;
  }
};

export default CalculatedValue;
